<template>
  <v-layout style="margin-top: 3px;" wrap>
    <v-flex md5 xs12>
      <v-checkbox
        v-model="featureData.checked"
        :label="feature['name_' + language] || feature.name_en"
        hide-details
      ></v-checkbox>
    </v-flex>
    <template v-for="(field, index) in fieldsArrayFromModule">
      <v-flex
        v-if="showFeatureField(field)"
        :key="index"
        v-bind="{[`xs${gridColumns(field)}`]: true}"
      >

        <!-- STRING -->
        {{ value.checked }}

        <div
          v-if="field.info.type === 'String' && showFeatureField(field)"
          class="pr-3"
        >
          <form-input
            v-model="featureData"
            :field="field"
            :label-text="labelText(field)"
            :module-name="moduleName"
          />
        </div>

        <!-- NUMBER -->

        <v-text-field
          v-else-if="field.info.type === 'Number' && showFeatureField(field)"
          v-model="featureData[field.fieldName]"
          :label="labelText(field)"
          hide-details
          one-liner
          outlined
          filled
          dense
          class="pr-3"
        />

        <!-- BOOLEAN -->

        <v-checkbox
          v-else-if="field.info.type === 'Boolean' && showFeatureField(field)"
          v-model="featureData"
          :label="translation(field.fieldName)"
        ></v-checkbox>

        <template v-else>
          {{ field.info }}
        </template>

      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import FormInput from './FormElements/FormInput'
import FormNumber from './FormElements/FormNumber'
import sharedComputed from './../computed'
import sharedMethods from './../methods'

export default {
  name: 'Feature',

  components: {
    FormNumber,
    FormInput
  },

  data () {
    return {
      featureData: {
        checked: false,
        quantity: null,
        distance: null,
        extraInfo: null
      },
      moduleName: 'featureFields'
    }
  },

  props: {
    field: {
      type: Object,
      default: () => {
        return {}
      }
    },

    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    feature: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  watch: {
    featureData: {
      handler: function (value) {
        if (!this.value[this.feature._id]) {
          this.value[this.feature._id] = {
            checked: false,
            quantity: null,
            distance: null,
            extraInfo: null
          }
        }
        this.value[this.feature._id].checked = value.checked
        this.value[this.feature._id].quantity = value.quantity
        this.value[this.feature._id].distance = value.distance
        this.value[this.feature._id].extraInfo = value.extraInfo
      },
      deep: true
    }
  },

  created () {
    if (this.value[this.feature._id]) {
      this.featureData = {
        checked: this.value[this.feature._id].checked,
        quantity: this.value[this.feature._id].quantity,
        distance: this.value[this.feature._id].distance,
        extraInfo: this.value[this.feature._id].extraInfo
      }
    } else {
      this.value[this.feature._id] = this.featureData = {
        checked: false,
        quantity: null,
        distance: null,
        extraInfo: null
      }
    }
  },

  computed: {
    ...sharedComputed,

    module () {
      return this.modules.featureFields
    }
  },

  methods: {
    ...sharedMethods,

    labelText (field) {
      return field.info['fieldNameText_' + this.language] || field.info.fieldNameText_en ||field.info.fieldName
    },

    showFeatureField (field) {
      if (field.fieldName === 'extraInfo') {
        // console.log('_showFeatureField', this.feature.name_en, this.feature)
      }
      return this.feature['define' + this.firstLetterUppercase(field.fieldName)]
    }
  }
}
</script>
